import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as Sentry from '@sentry/browser';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import App from './containers/App';
import history from './utils/history';

import './assets/css/tailwind.css';
import './helpers/config';
import './i18n';

import configureStore from './configureStore';

import ErrorBoundary from 'components/ErrorBoundary';
import { loadFurnitureAction } from 'containers/Configurator/actions/furniture';
import './helpers/refresher';
import { saveFurnitureRequestAction } from './containers/UserActions/actions';
import {
  updateCabinetMissingImage,
  updateFurnitureMissingImage,
} from './helpers/imageUpdater';
import { SaveMode } from './containers/UserActions/constants';

// Create redux store with history
const initialState = {};
export const store = configureStore(initialState, history);

const MOUNT_NODE = document.getElementById('kewconf') as HTMLElement;

let threeError = false;

export function loadCabinetOrFurniture(furnitureOrCabinetId?: string) {
  if (furnitureOrCabinetId) {
    store.dispatch(loadFurnitureAction(furnitureOrCabinetId));
  } else {
    store.dispatch(loadFurnitureAction());
  }
}
// @ts-ignore
window.loadCabinetOrFurniture = loadCabinetOrFurniture;

export function triggerAddToCart() {
  store.dispatch(saveFurnitureRequestAction(SaveMode.AddToCart));
}
// @ts-ignore
window.triggerAddToCart = triggerAddToCart;

export function triggerSave() {
  store.dispatch(saveFurnitureRequestAction());
}
// @ts-ignore
window.triggerSave = triggerSave;

// Export other global functions
// @ts-ignore
window.updateCabinetMissingImage = updateCabinetMissingImage;
// @ts-ignore
window.updateFurnitureMissingImage = updateFurnitureMissingImage;

if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_SENTRY_URL) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URL,
    beforeSend(event, hint) {
      if (hint) {
        const error = hint.originalException;
        if (error instanceof Error) {
          if (
            error &&
            error.message &&
            error.message.match(/getBoundingClientRect/i)
          ) {
            event.fingerprint = ['getBoundingClientRect'];
            return null;
          }
        }
      }

      return event;
    },
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category === 'ui.click') {
        if (hint) {
          const { target } = hint.event;
          if (target.ariaLabel) {
            breadcrumb.message = target.ariaLabel;
          }
        }
      }
      return breadcrumb;
    },
  });
}

// store.dispatch(setContextAction(getContext(window.location.href)));

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>,
  MOUNT_NODE,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// expose store when run in Cypress
// @ts-ignore
// if (window.Cypress) {
//   // @ts-ignore
//   window.store = store;
// }
